var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcAnimalsDairyReplacements(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.27 15C44.8719 14.6472 44.9665 14.2857 44.9999 13.5714C45.0332 12.8574 39.2857 7.85714 39.2857 7.85714L38.5714 5C38.5714 5 37.0272 6.98189 35.7143 7.85714C33.5713 9.28571 33.9631 10.9385 30 11.4286C19.6973 12.7027 12.3113 10.7143 7.11119 10.7143C5.68261 10.7143 2.85715 12.1429 2.82547 13.5714C2.80962 14.2862 1.64711 23.0976 2.14286 23.5714C3.17442 24.5573 4.25404 15 4.25404 15C4.25404 15 5.56423 17.9875 5 22.1429C4.6905 24.4222 2.14286 25.7143 2.14286 25.7143L0 40.7143H2.14286C2.14286 40.7143 5.68261 29.2857 6.3969 27.8571C8.53976 27.8571 10.6826 24.2857 10.6826 24.2857H28.5398L33.5696 40.7143H35.7141L32.857 26.4286C32.857 26.4286 34.2769 25.3241 34.9683 24.2857C36.3952 22.1429 37.8571 14.2857 37.8571 14.2857C37.8571 14.2857 38.1091 15.0632 38.344 15.1119C39.5706 15.3661 42.737 15.8985 44.27 15Z",
    fill: "#CB5E03"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5713 29.2857L27.1427 25.7143H25.7141L24.9999 40.7143H26.4284L28.5713 29.2857Z",
    fill: "#CB5E03"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4284 25.7143H12.1427L13.5713 40.7143H11.4284L9.28557 28.5714C9.28557 28.5714 9.50751 28.2401 9.99986 27.8571C10.7938 27.2397 11.4284 25.7143 11.4284 25.7143Z",
    fill: "#CB5E03"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAnimalsDairyReplacements);
export default __webpack_public_path__ + "static/media/ic-animals-dairy-replacements.a8b8193d2cc03caaaf67ebc9164f79ba.svg";
export { ForwardRef as ReactComponent };